import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { judgeDetailPageStateModuleName } from '@/store/modules/modules'

export class JudgeDetailPageStateViewModel {
  private store = useStore()

  isHideJudgeCaseList: ComputedRef<boolean[]> = computed(
    () => this.store.getters[`${judgeDetailPageStateModuleName}/isHideJudgeCaseList`]
  )

  setIsHideJudgeCaseList(isHideJudgeCaseList: boolean[]): void {
    this.store.commit(`${judgeDetailPageStateModuleName}/setIsHideJudgeCaseList`, { isHideJudgeCaseList })
  }

  setFlagIsHideJudgeCaseList(index: number, flag: boolean): void {
    this.store.commit(`${judgeDetailPageStateModuleName}/setFlagIsHideJudgeCaseList`, { index, flag })
  }
}
